<!-- Department header -->
<app-dept-header *ngIf="showDeptMenu"></app-dept-header>

<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section class="events" id="events">
            <header><h1>{{infoTitle}}</h1></header>
            <div class="section-content">

              <article class="event" *ngFor="let dataItem of allData let i=index">
                <a routerLink="/info/{{dataItem.id}}">
                  <figure class="date">
                    <div class="month">{{ dataItem.commence_date | date:'MMM' }}</div>
                    <div class="day">{{ dataItem.commence_date | date:'d' }}</div>
                  </figure>
                </a>
                <aside>
                  <header>
                    <a routerLink="/info/{{dataItem.id}}">
                      {{dataItem.title}}
                    </a>
                  </header>

                  <div class="additional-info"><span class="fa fa-calendar"></span>
                    <span> {{ dataItem.commence_date | date:'MMMM d, y' }}</span>
                    <span *ngIf="dataItem.complete_date != dataItem.commence_date">
                        to {{ dataItem.complete_date | date:'MMMM d, y' }}
                      </span>
                  </div>

                  <div class="description">
                    <p>
                      {{dataItem.short_desc}}
                    </p>
                  </div>
<!--                  <a href="event-detail.html" class="btn btn-framed btn-color-grey btn-small">View Details</a>-->
                </aside>
              </article><!-- /article -->
            </div><!-- /.section-content -->
          </section><!-- /.events -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <aside class="news-small" id="news-small">
            <header>
              <h2>All {{infoTitle}}</h2>
            </header>
            <div class="section-content">
              <article *ngFor="let dataItem of allData">
                <figure class="date"><i class="fa fa-calendar"></i>{{ dataItem.commence_date | date:'MMMM d, y' }}</figure>
                <header>
                  <a routerLink="/info/{{dataItem.id}}">
                    {{dataItem.title.slice(0,50)}}...
                  </a>
                </header>
              </article><!-- /article -->
            </div><!-- /.section-content -->
          </aside><!-- /.news-small -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
